import React from 'react';
import { FilteredTable, Link, Text } from '@common/components';
import { TableColumnType } from 'antd';
import { SupplierStatus } from '@institutions/components';
import { Supplier } from '@institutions/graphql/queries/tiers-query';
import { buildDialogUrl } from '@common/services';
import { FontSize } from '@common/tokens';

const LOCAL_STORAGE_FILTER_KEY =
  'suppliers-management-tiers-drawer-tier-suppliers';

type SuppliersManagementTiersDrawerTierSuppliersProps = {
  loading: boolean;
  suppliers: Supplier[];
};

export function SuppliersManagementTiersDrawerTierSuppliers({
  loading,
  suppliers,
}: SuppliersManagementTiersDrawerTierSuppliersProps) {
  const columns: TableColumnType<Supplier>[] = [
    {
      title: 'Name',
      key: 'name',
      render: (record) => (
        <Link
          to={buildDialogUrl('supplier-view-drawer', {
            props: { supplierId: record.id },
          })}
        >
          <Text bold color="elm">
            {record.name}
          </Text>
        </Link>
      ),
    },
    {
      title: 'Status',
      dataIndex: ['statusForCurrentOrganization', 'status'],
      key: 'status',
      render: (value) => <SupplierStatus status={value} />,
    },
  ];

  return (
    <>
      <FilteredTable
        columns={columns}
        dataSource={suppliers}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 10000,
          hideOnSinglePage: true,
        }}
        scroll={{ x: '100%' }}
        className="suppliers-management-tiers-drawer-tier-suppliers__table"
        localStorageFilterKey={LOCAL_STORAGE_FILTER_KEY}
        onChange={undefined}
        onFilterChange={undefined}
        filters={undefined}
      />
      {suppliers.length > 0 && (
        <Text color="midnightRegular">
          Showing all {suppliers.length} supplier{suppliers.length !== 1 && 's'}
        </Text>
      )}
      <style jsx>{`
        :global(.suppliers-management-tiers-drawer-tier-suppliers__table) {
          margin-bottom: 16px;
        }
        :global(
          .suppliers-management-tiers-drawer-tier-suppliers__table
            .tiering-action
        ) {
          font-size: ${FontSize.xs};
          font-weight: 800;
        }
        :global(
          .suppliers-management-tiers-drawer-tier-suppliers__table
            .ant-table-tbody
            > tr
            > td
        ) {
          padding: 14px 4px 14px 8px;
        }
      `}</style>
    </>
  );
}
